module.exports = __webpack_public_path__ + "img/second.c2a94b6e.png";